import { apiList } from '../api/apiList'
import axiosInstance2 from '../api/axiosInstance2'

const endpoint = apiList.bankAccountApi

const bankAccountService = {
  list: () => axiosInstance2.get(endpoint),
  create: (payload) => axiosInstance2.post(endpoint, payload),
  update: (payload) => axiosInstance2.put(endpoint, payload),
  remove: (id) => axiosInstance2.post(`${endpoint}/${id}`),
}

export default bankAccountService
